import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CompanyLogo from "../../assets/images/Company-Logo.png";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SettingsIcon from "@mui/icons-material/Settings";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ForwardIcon from "@mui/icons-material/Forward";
import { User } from "@auth0/auth0-react";
import HelpModal from "./HelpModal";
import { Tooltip, Button, Card, Popover } from "@mui/material";
import Carousel from "react-bootstrap/Carousel";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  getDashboardCounts,
  getDownStreamDetails,
  getPreworkDashboardDetails,
  getUserAccountsData,
} from "../../api/userAccountsApi/userAccountsApi";
import MenuIcon from "@mui/icons-material/Menu";
import SellIcon from "@mui/icons-material/Sell";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import SwitchEnvModal from "./SwitchEnvModal";
import LogoutConfirmDialog from "../LogoutConfirmDialog/LogoutConfirmDialog";
import DashboardModal from "./DashboardModal";
import isPagePermission from "../../utils/common";
import LocalStorageUtil from "../../utils/localStorage";
import { appSettings } from "../../config/appSetting";
interface AppBarComponentProps {
  logout: () => any;
  user?: User | null;
  getBusinessUnitData: (id: any) => any;
  businessUnitData: any;
}

const AppBarComponent: React.FC<AppBarComponentProps> = ({
  logout,
  user,
  getBusinessUnitData,
  businessUnitData,
}) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [accountData, setAccountData] = useState<any>([]);
  const [filteredAccount, setFilteredAccount] = useState<any>(null);
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [preworkDashboardData, setPreworkDashboardData] = useState<any[]>([]);
  const [title, setTitle] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const open = Boolean(anchorEl);
  const [openModal, setOpenModal] = React.useState(false);
  const [openEnvModal, setOpenEnvmodal] = React.useState(false); // NOSONAR
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);
  const handleOpenEnv = () => setOpenEnvmodal(true);
  const handleCloseEnv = () => setOpenEnvmodal(false);
  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [preworkFullView, setPreworkFullView] = useState<any[]>([]);
  const DASHBOARD_CAROUSEL_PAGE_SIZE = 3;
  const handleSubMenuOpen = (event: any) => {
    setSubMenuAnchorEl(event.currentTarget);
  };

  const handleSubMenuClose = () => {
    setSubMenuAnchorEl(null);
  };
  const subMenuOpen = Boolean(subMenuAnchorEl);
  const items = [
    {
      title: "PW Preflight",
      action1: dashboardData?.prworkNewCount,
      action2: dashboardData?.preflightCount,
      permission: ["Allow PreFlight"],
      id: 752,
    },
    {
      title: "PW Final",
      action1: dashboardData?.fromPreflightCount,
      action2: dashboardData?.finalCount,
      permission: ["Allow Final"],
      id: 753,
    },
    {
      title: "PW Full View",
      action1: dashboardData?.prworkNewCount,
      action2: dashboardData?.finalCount,
      permission: ["Allow Fullview"],
      id: 756,
    },
    {
      title: "Print",
      action1: dashboardData?.toDAO,
      action2: dashboardData?.daoReturn,
      permission: ["Allow_PrintDelivery", "Allow Print"],
      id: 754,
    },
    {
      title: "DSA",
      action1: dashboardData?.toDSA,
      action2: dashboardData?.dsaReturn,
      permission: ["Allow DSA"],
      id: 757,
    },
    {
      title: "eDEL",
      action1: dashboardData?.toEdelivery,
      action2: dashboardData?.edeliveryReturn,
      permission: ["Allow_eDelivery"],
      id: 755,
    },
  ];

  const handleLogoClick = () => {
    navigate("/");
  };

  const fetchUserAccounts = async () => {
    const payload = {
      contextName: LocalStorageUtil.getItem("contextName"),
      isSuperAdmin: Number(LocalStorageUtil.getItem("isSuperAdmin")),
      primaryGroupId: LocalStorageUtil.getItem("groupId"),
      userId: LocalStorageUtil.getItem("userId"),
    };
    try {
      const response = await getUserAccountsData(payload);
      setAccountData(response);
    } catch (error) {
      console.log("failed to load", error);
    }
  };

  const fetchPreworkDetailsData = async () => {
    const payload = {
      Accountid: LocalStorageUtil.getItem("accountId"),
      Timezone: appSettings.timezone,
      contextName: LocalStorageUtil.getItem("contextName"),
    };
    try {
      const response = await getDashboardCounts(payload);
      setDashboardData(response);
    } catch (error) {
      console.log("failed to load", error);
    }
  };

  useEffect(() => {
    if (LocalStorageUtil.getItem("contextName")) fetchUserAccounts();
    fetchPreworkDetailsData();
  }, [LocalStorageUtil.getItem("contextName")]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchPreworkDetailsData();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const contextName = LocalStorageUtil.getItem("contextName");
    if (contextName) {
      const matchedAccount = accountData
        .map((account: any) => account)
        .find((account: any) => account?.contextName === contextName);
      if (matchedAccount) {
        setFilteredAccount(matchedAccount);
      } else {
        setFilteredAccount(null);
      }
    }
  }, [accountData]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseSetting = () => {
    setAnchorEl(null);
  };

  const handleColumnHeadersClick = () => {
    navigate("/columnHeaders");
    handleCloseSetting();
  };

  const handleMetaDataFieldsClick = () => {
    navigate("/metaData", { state: { action: "metaData" } });
    handleCloseSetting();
  };

  const handleDashboardClick = (index: any) => {
    if (index <= 3) {
      switch (index) {
        case 1:
          setTitle("Export to Preflight");
          break;
        case 2:
          setTitle("Move to Final");
          break;
        case 3:
          setTitle("Prework Full View");
          break;
        case 4:
          setTitle("DownStream Print View");
          break;
        case 5:
          setTitle("DownSample View");
          break;
        case 6:
          setTitle("DownStream Edelivery View");
          break;
        default:
          setTitle("");
      }
      fetchPreworkDashboard(index);
    } else {
      switch (index) {
        case 4:
          setTitle("DownStream Print View");
          break;
        case 5:
          setTitle("DownSample View");
          index = 6;
          break;
        case 6:
          setTitle("DownStream Edelivery View");
          index = 5;
          break;
        default:
          setTitle("");
      }
      fetchSecondApi(index);
    }
  };

  const fetchPreworkDashboard = async (finalIndex: any) => {
    const payload = {
      sortColumn: "",
      sortOrder: 0,
      currentPage: 1,
      noOfRecords: 100,
      AccountId: LocalStorageUtil.getItem("accountId"),
      DashboardType: finalIndex,
      Timezone: appSettings.timezone,
      contextName: LocalStorageUtil.getItem("contextName"),
    };
    try {
      const response = await getPreworkDashboardDetails(payload);
      setPreworkDashboardData(response?.listDashboardActivity);
      setPreworkFullView(response);
      console.log("preworkDashboardData", response);
      setIsModalOpen(true);
    } catch (error) {
      console.log("failed to load", error);
    }
  };

  const fetchSecondApi = async (finalIndex: any) => {
    const payload = {
      sortColumn: "",
      sortOrder: 0,
      currentPage: 1,
      noOfRecords: 100,
      AccountId: LocalStorageUtil.getItem("accountId"),
      DashboardType: finalIndex,
      Timezone: appSettings.timezone,
      contextName: LocalStorageUtil.getItem("contextName"),
    };
    try {
      const response = await getDownStreamDetails(payload);
      setPreworkDashboardData(response.listDashboardActivity);
      console.log("preworkDashboardData", response);
      setIsModalOpen(true);
    } catch (error) {
      console.log("failed to load", error);
    }
  };

  const visibleItems = items.filter((item) =>
    Array.isArray(item.permission)
      ? item.permission.some((p) => isPagePermission(p, "DashBoard", item.id))
      : isPagePermission(item.permission, "DashBoard", item.id)
  );

  return (
    <AppBar
      position="static"
      sx={{ background: "white", height: 60 }}
      style={{
        borderBottom: "0.1875em solid #2678c4",
        position: "fixed",
        zIndex: "100",
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.3125em" }}>
          <Typography variant="h6">
            <button
              type="button"
              onClick={handleLogoClick}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
              aria-label="Export to Excel"
            >
              <img
                src={CompanyLogo}
                alt="Doc-Distro"
                style={{ cursor: "pointer", height: "50px" }}
              />
            </button>
          </Typography>
          <div
            style={{
              height: "30px",
              width: "1px",
              backgroundColor: "#ccc",
              margin: "0 10px",
            }}
          ></div>
          <div key={filteredAccount?.accountId}>
            <Tooltip
              title={
                <>
                  {LocalStorageUtil.getItem("contextName")}
                  <br />
                  Click on the logo to switch environment
                </>
              }
              arrow
            >
              <button
                type="button"
                onClick={handleOpenEnv}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                }}
                aria-label="Export to Excel"
              >
                <img
                  src={businessUnitData?.logoPath || filteredAccount?.logoPath}
                  alt={filteredAccount?.accountName}
                  style={{ height: "40px", cursor: "pointer" }}
                />
              </button>
            </Tooltip>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ marginLeft: "10px", position: "relative" }}>
            <Carousel
              indicators={false}
              controls={true}
              interval={null}
              prevIcon={
                visibleItems.length > DASHBOARD_CAROUSEL_PAGE_SIZE && (
                  <IconButton>
                    <ArrowBackIosIcon fontSize="small" />
                  </IconButton>
                )
              }
              nextIcon={
                visibleItems.length > DASHBOARD_CAROUSEL_PAGE_SIZE && (
                  <IconButton>
                    <ArrowForwardIosIcon fontSize="small" />
                  </IconButton>
                )
              }
              style={{ width: "400px" }}
            >
              {[0, 1].map((page) => (
                <Carousel.Item key={page}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginRight: "10px",
                    }}
                  >
                    {items
                      .slice(page * 3, page * 3 + 3)
                      .filter((item) =>
                        Array.isArray(item.permission)
                          ? item.permission.some((p) =>
                              isPagePermission(p, "DashBoard", item.id)
                            )
                          : isPagePermission(
                              item.permission,
                              "DashBoard",
                              item.id
                            )
                      )
                      .map((item, index) => (
                        <Card
                          key={item.id}
                          style={{
                            padding: "7px 7px 0 7px",
                            textAlign: "center",
                            borderRadius: "0px",
                            marginBottom: "5px",
                            borderRight: "2px solid #006ab6",
                            borderLeft: "2px solid #006ab6",
                            width: "130px",
                          }}
                          onClick={() => {
                            handleDashboardClick(page * 3 + index + 1);
                          }}
                        >
                          <Typography
                            variant="caption"
                            style={{
                              color: "#006ab6",
                              marginBottom: "5px",
                              fontWeight: "bold",
                            }}
                          >
                            {item.title}
                          </Typography>
                          <div>
                            <Button
                              variant="outlined"
                              size="small"
                              style={{
                                fontSize: "9px",
                                padding: "2px 6px",
                                lineHeight: 1,
                                minWidth: "40px",
                                color: "white",
                                marginRight: "10px",
                              }}
                            >
                              {item.action1}
                            </Button>
                            {item.title !== "Print" && item.title !== "DSA" && (
                              <Button
                                variant="outlined"
                                size="small"
                                style={{
                                  fontSize: "9px",
                                  padding: "2px 6px",
                                  lineHeight: 1,
                                  minWidth: "40px",
                                }}
                              >
                                {item.action2}
                              </Button>
                            )}
                          </div>
                        </Card>
                      ))}
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginLeft: "20px",
            }}
          >
            <Typography variant="body1" sx={{ color: "black" }}>
              <span style={{ color: "#006ab6", fontWeight: "bold" }}>Hi,</span>{" "}
              {LocalStorageUtil.getItem("firstName") +
                " " +
                LocalStorageUtil.getItem("lastName")}
            </Typography>
            <div style={{ display: "flex", gap: "4px" }}>
              <Tooltip title="Click to view User Preferences">
                <IconButton onClick={handleClick}>
                  <SettingsIcon sx={{ fontSize: 18, color: "#006ab6" }} />
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseSetting}
                slotProps={{
                  paper: {
                    style: {
                      maxHeight: 200,
                      width: "200px",
                    },
                  },
                }}
              >
                {isPagePermission("", "", 1376) && (
                  <MenuItem onClick={handleColumnHeadersClick}>
                    <Typography variant="body2">
                      <MenuIcon
                        style={{ marginRight: "5px", color: "#006ab6" }}
                      />
                      Column Headers
                    </Typography>
                  </MenuItem>
                )}
                {isPagePermission("", "", 1377) && (
                  <MenuItem onClick={handleMetaDataFieldsClick}>
                    <Typography variant="body2">
                      <SellIcon
                        style={{ marginRight: "5px", color: "#006ab6" }}
                      />
                      MetaData Fields
                    </Typography>
                  </MenuItem>
                )}
                <MenuItem
                  onMouseEnter={handleSubMenuOpen}
                  onMouseLeave={handleSubMenuClose}
                >
                  <Typography variant="body2">
                    <GTranslateIcon
                      style={{ marginRight: "5px", color: "#006ab6" }}
                    />
                    Language Settings
                  </Typography>
                  <Popover
                    open={subMenuOpen}
                    anchorEl={subMenuAnchorEl}
                    onClose={handleSubMenuClose}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    slotProps={{
                      paper: {
                        style: {
                          width: "150px",
                        },
                      },
                    }}
                  >
                    <MenuItem
                      className="context-menu-item"
                      onClick={() => alert("English Selected")}
                    >
                      English
                    </MenuItem>
                    <MenuItem
                      className="context-menu-item"
                      onClick={() => alert("Spanish Selected")}
                    >
                      Spanish
                    </MenuItem>
                    <MenuItem
                      className="context-menu-item"
                      onClick={() => alert("German Selected")}
                    >
                      German
                    </MenuItem>
                  </Popover>
                </MenuItem>
              </Menu>
              <IconButton onClick={handleOpen}>
                <Tooltip title="Click to view the help documents">
                  <HelpOutlineIcon sx={{ fontSize: 18, color: "#006ab6" }} />
                </Tooltip>
              </IconButton>
              <IconButton onClick={() => setIsOpen(true)}>
                <Tooltip title="Click to logout from the System">
                  <ForwardIcon sx={{ fontSize: 18, color: "#006ab6" }} />
                </Tooltip>
              </IconButton>
              <LogoutConfirmDialog
                open={isOpen}
                onClose={(confirmed) => {
                  setIsOpen(false);
                  if (confirmed) {
                    logout();
                  }
                }}
              />
            </div>
          </div>
          {openModal && <HelpModal open={openModal} onClose={handleClose} />}
          <SwitchEnvModal
            open={openEnvModal}
            onClose={handleCloseEnv}
            EnvironmentData={accountData}
            getBusinessUnitData={getBusinessUnitData}
          />
        </div>
        <DashboardModal
          title={title}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          data={preworkDashboardData}
          preworkFullView={preworkFullView}
        />
      </Toolbar>
    </AppBar>
  );
};

export default AppBarComponent;
